<template>
	<div>
		<b-card no-body class="mb-3 pl-3 pr-3 pt-3 pb-3">
			<h2>Estimasi Work Order</h2>
		</b-card>
		<panel class="" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox" style="padding:0">
				<div class="col row">
					<div class="col-md-3 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Cari</label>
						<input
							type="text"
							class="form-control"
							v-on:keyup.enter="vue_universal_table.update++"
							placeholder="Ketik teks"
							style="height: 43px;"
							v-model="filter.search"
						/>
					</div>
					<div class="col-md-3 mt-1" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Status Pekerjaan</label>
						<Multiselect
							:options="completeFilter.map(x => x.completed)"
							:custom-label="
								opt =>
									completeFilter.find(x => x.completed == opt)
										.name
							"
							v-model="filter.completed"
							placeholder="Pilih Status"
						/>
					</div>
					<div class="col-md-3 mt-1" :class="mobile ? 'pt-20' : ''">
						<label>Periode</label>
						<!-- <date-range-picker 
							class="w-100 mr-4"
							v-model="selected.date"
							style="height:43px;padding-top:8px"
							ref="picker"
							:opens="'left'"
							:ranges="rangeOption"
							:autoApply="true"
						>
							<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
								<i class="fa fa-calendar fa-fw ml-n1"></i> 
									{{ moment(picker.startDate).format("MMM DD, Y")}} - {{ moment(picker.endDate).format("MMM DD, Y")}}
								<b class="caret"></b>
							</template>
						</date-range-picker> -->
						<div class="block w-100 datepickerSeperator">
							<DatePicker
								class="w-100"
								v-model="selected.date"
								type="monthrange"
								align="right"
								format="MMM yyyy"
								range-separator="-"
								start-placeholder="Start"
								end-placeholder="End"
								:picker-options="pickerOptions"
								style="height:43px">
							</DatePicker>
						</div>
					</div>
					<div
						class="col-md-3 mt-1"
						style="display: flex; flex-direction: column-reverse"
						:class="mobile ? 'pt-20' : ''"
					>
						<button
							type="button"
							class="btn btn-primary"
							style="height:43px; margin-bottom:0.5%"
							@click="vue_universal_table.update++"
						>
							Filter
						</button>
					</div>
				</div>
			</div>
		</panel>

		<!-- <div class="shadow pt-3 pl-3 pr-3 pb-3 rounded hoverStatus">
		<div class="row " @click="showStatus = !showStatus">
			<div class="col-9 pl-3">
				<h5 v-if="!showStatus">Show Status Work Order</h5>
				<h5 v-else>Hide Status Work Order</h5>
			</div>
			<div class="col-3 text-right pr-5">
				<i class="fa fa-arrow-down fa-lg"></i>
			</div>
		</div>
	</div> -->
		<div class="pl-2 pr-2" v-if="showStatus">
			<div class="row shadow rounded p-20">
				<div
					class=" col-md-6 col-12 mt-3 mb-3 border border-secondary p-20 rounded "
				>
					<h4>Status Work Order</h4>

					<div class="row mt-2" v-if="woStatus">
						<div class="col-md-12">
							<!-- <template v-for="(wo , index) in woStatus" >
							<table>
								<div class="col-md-4">
									<h5>{{wo.name}}</h5>
								</div>
								<div class="col-md-2">
									:
								</div>
								<div class="col-md-4  text-center">
									{{wo.count}} / {{woStatus.find(x => x.name == 'Total').count}}
								</div>
							</div>
						</template> -->

							<table class="table table-hover">
								<tbody
									v-for="(wo, index) in woStatus"
									:key="index"
								>
									<tr
										v-if="wo.name != 'Total'"
										@click="showDetailLog(wo.id, wo.name)"
									>
										<th>{{ wo.name }}</th>
										<td>:</td>
										<td class="text-center">
											{{ wo.count }} /
											{{
												woStatus.find(
													x => x.name == "Total"
												).count
											}}
										</td>
										<td class="text-center">
											<i class="fa fa-arrow-right"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div
					class="col-md-6 col-12 mt-3 mb-3 pl-3 pr-3"
					v-if="woStatusLog"
				>
					<div class="">
						<h5>WO Yang Belum {{ logName }}</h5>
						<div
							class="border border-secondary w-100 rounded bg-grey p-10"
							style="font-weight:bold"
						>
							{{
								woStatusLog
									.filter(x => x.status == 0)
									.map(
										x =>
											`${x.form_code} - ${x.registration}`
									)
									.join(" , ")
							}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <hr /> -->

		<!-- <div class="mt-3 row pl-2 pr-2">
			<div class=" col-12 border border-secondary rounded p-10">
				<h5>Legend :</h5>
				<div class="row ">
					<div class="row mt-2 col">
						<div class="col-2">
							<div
								style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#9BE880"
							></div>
						</div>
						<div class="col-8 ">
							<h6>Estimasi Selesai</h6>
						</div>
					</div>
					<div class="row mt-2 col">
						<div class="col-2">
							<div
								style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#81C29C"
							></div>
						</div>
						<div class="col-8">
							<h6>Mobil Keluar</h6>
						</div>
					</div>
					<div class="row mt-2 col">
						<div class="col-2">
							<div
								style="border: 1px solid black;border-radius:20px;width:1em;height:1em;background-color:#89F1DB "
							></div>
						</div>
						<div class="col-8 ">
							<h6>Mobil Sudah Terbayar</h6>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<div class="row mt-3">
			<div class="col-md-6 col-12 mt-1">
				<button
					class="btn btn-danger  w-100"
					v-if="showDeleted == false"
					@click="
						showDeleted = true;
						vue_universal_table.update++;
					"
				>
				Lihat Form Yg Di Batalkan
				</button>
				<button
					class="btn btn-warning w-100"
					v-else
					@click="
						showDeleted = false;
						vue_universal_table.update++;
					"
				>
					Sembunyikan Form Yg Di Batalkan
				</button>
			</div>
			<div class="col-md-6 col-12 mt-1">
				<button class="btn btn-primary w-100" @click="createNewWorkOrder">
					Create Work Order
				</button>
			</div>
		</div>

		
		<b-card no-body class="mt-4 card-workorder">
			<b-tabs card
				active-nav-item-class="font-weight-bold text-white bg-black"
				v-model="tabController"
			>
				<b-tab title="Belum SPK" active>
					<vue-universal-table
						class=""				
						
						:buttons="vue_universal_table.buttons"
						:dummy_table="false"
						:filter="filter"
						:fields="vue_universal_table.fields"
						:update="vue_universal_table.update"
						api_url="/api/v1/workorder/listing?spk=noSpk"
						:process_data="
							showDeleted
								? vue_universal_table.process_data
								: vue_universal_table.process_data_delete
						"
						:disable_sort="true"
						@onCreateWo="createNewWorkOrder"
						@onDetail="viewDetailWO"
						@onEstimasi="viewEstimasiWO"
						@onIsiData="isiData"
					></vue-universal-table>	
				</b-tab>
				<b-tab title="Sudah SPK">
					<vue-universal-table
						class=""
						:buttons="vue_universal_table.buttons"
						:dummy_table="false"
						:filter="filter"
						:fields="vue_universal_table.fields"
						:update="vue_universal_table.update"
						api_url="/api/v1/workorder/listing?spk=onlySpk"
						:process_data="
							showDeleted
								? vue_universal_table.process_data
								: vue_universal_table.process_data_delete"
						:disable_sort="true"
						@onCreateWo="createNewWorkOrder"
						@onDetail="viewDetailWO"
						@onEstimasi="viewEstimasiWO"
						@onIsiData="isiData"
						@getCurrentPage="isiPage"
						:page="page"
					></vue-universal-table>
					<!-- <b-card-text>Tab contents 2</b-card-text> -->
				</b-tab>
				<b-tab title="Process Mobil">
					<vue-universal-table
						class=""
						:buttons="vue_universal_table.buttons"
						:dummy_table="false"
						:filter="filter"
						:fields="vue_universal_table.fields"
						:update="vue_universal_table.update"
						api_url="/api/v1/workorder/listing?spk=processOnly"
						:process_data="
							showDeleted
								? vue_universal_table.process_data
								: vue_universal_table.process_data_delete"
						:disable_sort="true"
						@onCreateWo="createNewWorkOrder"
						@onDetail="viewDetailWO"
						@onEstimasi="viewEstimasiWO"
						@onIsiData="isiData"
						@getCurrentPage="isiPage"
						:page="page"
					></vue-universal-table>
					<!-- <b-card-text>Tab contents 2</b-card-text> -->
				</b-tab>
				<b-tab title="Parts Only">
					<vue-universal-table
						class=""
						:buttons="vue_universal_table.buttonsPartsOnly"
						:dummy_table="false"
						:filter="filter"
						:fields="vue_universal_table.fieldsPartsOnly"
						:update="vue_universal_table.update"
						api_url="/api/v1/workorder/listing?spk=beliSparepart"
						:process_data="
							showDeleted
								? vue_universal_table.process_data
								: vue_universal_table.process_data_delete"
						:disable_sort="false"
						@onDaftarPembelian="viewPurchaseList"
						@getCurrentPage="isiPage"
						:page="page"
					></vue-universal-table>
				
				</b-tab>
			</b-tabs>
		</b-card>
		

		
	</div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import DateRangePicker from 'vue2-daterange-picker'

import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(lang)

export default {
	data() {
		const start = moment()
			.subtract(5, "months")
			.startOf("month")
			.format("YYYY-MM-DD");
		let end = new moment().endOf("month").format("YYYY-MM-DD");

		let filter = 
			{
				start: start,
				end: end,
				search: "",
				completed: null
			};
		let page = 1;
		console.log(filter)

		return {
			tabController : 0,
			moment,
			// rangeOption : [],
			pickerOptions: {
				shortcuts: [{
					text: 'Bulan Ini',
					onClick(picker) {
						picker.$emit('pick', [new Date(), new Date()]);
					}
				}, {
					text: 'Tahun Ini',
					onClick(picker) {
						const end = new Date();
						const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '6 Bulan Terakhir',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			data: null,
			showStatus: false,
			woStatus: null,
			woStatusLog: null,
			logName: null,
			showDeleted: false,
			filter: filter,
			page: page,
			completeFilter: [
				{
					name: "Sedang Pengerjaan",
					completed: "false"
				},
				{
					name: "Mobil Sudah Keluar",
					completed: "true"
				},
				{
					name: "Pending Parts",
					completed: "pending_parts"
				},
				{
					name: "Belum Terbayar",
					completed: "not_paid"
				}
			],
			meta: null,
			data: null,
			mobile: this.isMobile(),
			selected : {
				date : [
					new Date().setMonth(new Date().getMonth() - 6),
					new Date()
				]
			},
			rangeConfig: {
				mode: "range",
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL()
			},
			showNewUserModal: false,
			apiLoading: true,
			vue_universal_table: {
				update: 0,
				process_data: `
					for (var i in data) {
						data[i].showWO = data[i].serviceType + data[i].form_code 
						data[i].created_at = new this.moment(data[i].created_at).format('DD MMM YYYY HH:mm')
						data[i].log_name = data[i].log ? data[i].log.name : '-'
						data[i].step_name = data[i].step ? data[i].step.name : '-'
						data[i].conditionChecked = data[i].conditionChecked ? 'Y' : 'N'
						data[i].estimationTotal = data[i].approved_estimations + ' / ' + data[i].estimations
						data[i].estimationCompleted = data[i].approved_estimations == data[i].estimations && data[i].estimations != 0
						
						if(data[i].log.id >= 8)
							data[i].statusWo = 'Sudah Dibayar'
						else if (data[i].log.id >= 7)
							data[i].statusWo = 'Kwitansi Dikirim'
						else if (data[i].log.id >= 6)
							data[i].statusWo = 'Sudah Penagihan'
						else if (data[i].log.id >= 5)
							data[i].statusWo = 'Mobil Keluar'
							
						else if(data[i].estimationCompleted)
							data[i].statusWo = 'Estimasi Selesai'
						else
							data[i].statusWo = '-'
					}
				`,
				process_data_delete: `
            
					data = data.filter(x => x.deleted_at == null)
					for (var i in data) {
						data[i].showWO = data[i].serviceType + data[i].form_code 
						data[i].created_at = new this.moment(data[i].created_at).format('DD MMM YYYY HH:mm')
						data[i].log_name = data[i].log ? data[i].log.name : '-'
						data[i].step_name = data[i].step ? data[i].step.name : '-'
						data[i].conditionChecked = data[i].conditionChecked ? 'Y' : 'N'
						data[i].estimationTotal = data[i].approved_estimations + ' / ' + data[i].estimations
						data[i].estimationCompleted = data[i].approved_estimations == data[i].estimations && data[i].estimations != 0

						if(data[i].log.id >= 8)
							data[i].statusWo = 'Sudah Dibayar'
						else if (data[i].log.id >= 7)
							data[i].statusWo = 'Kwitansi Dikirim'
						else if (data[i].log.id >= 6)
							data[i].statusWo = 'Sudah Penagihan'
						else if (data[i].log.id >= 5)
							data[i].statusWo = 'Mobil Keluar'
						else if(data[i].estimationCompleted)
							data[i].statusWo = 'Estimasi Selesai'
						else
							data[i].statusWo = '-'
					}
            	`,
				special_buttons: ["CreateWo"],
				buttons: [
					{
						title: "IsiData",
						condition: "!data.car_name",
						class: "btn btn-outline-info"
					},
					{
						title: "detail",
						// variable: "form_code",
						class: "btn-outline-danger fas fa-eye"
					},
					{
						title: "estimasi",
						class: "btn-outline-secondary fas fa-clipboard-list"
					}
				],
				buttonsPartsOnly: [
					{
						title : 'DaftarPembelian',
						class : 'btn btn-outline-success fas fa-dollar-sign'
					}
				],
				fieldsPartsOnly : [{
					title : 'No WO',
					variable : 'showWO'
				}, {
					title : 'Nama Pelanggan',
					variable : 'customer_name'
				}, {
					title : 'Tipe Mobil',
					variable : 'car_name'
				}, {
					title : 'Nomor Polisi Mobil',
					variable : 'registration'
				} ,{
					title : 'Tanggal Pesan',
					variable : 'created_at'
				}],
				fields: [
					{
						title: "No WO",
						variable: "showWO"
					},
					{
						title: "No Polisi",
						variable: "registration"
					},
					{
						title: "Nama Pelanggan",
						variable: "customer_name"
					},
					{
						title: "Tipe Mobil",
						variable: "car_name"
					},
					{
						title: "Asuransi",
						variable: "insurance_company"
					},
					{
						title: "Status Estimasi",
						variable: "estimationTotal"
					},
					// {
					//   title : 'Status Mobil',
					//   variable : 'log_name'
					// },
					// {
					//   title : 'Step Pekerjaan Terakhir',
					//   variable : 'step_name'
					// },
					{
						title: "Tanda Terima",
						variable: "conditionChecked",
						style_condition: {
							Y: "color : #2E8B57;font-weight:bold",
							N: "color : red;font-weight:bold"
						}
					},
					
					{
						title: "Aging WO",
						variable: "aging"
					},
					
					{
						title: "Tanggal Masuk",
						variable: "created_at"
					},
					{
						title : 'Status',
						variable : 'statusWo',
						style_condition : {
							'Estimasi Selesai' : 'color : #e5b608;font-weight:bold',
							'Mobil Keluar' : 'color : #0ca124;font-weight:bold',
							'Sudah Dibayar' : 'color : #0cc59a;font-weight:bold',
							'Sudah Penagihan' : 'color : #808B91;font-weight:bold',
							'Kwitansi Dikirim' : 'color : #4AB5D6;font-weight:bold',
						}
					}

					// {
					//   title : 'CSO',
					//   variable : 'CSO'
					// }
				]
			}
		};
	},
	components: {
		Multiselect,
		// DateRangePicker,
		DatePicker
	},
	mounted() {
		// this.getWoStatus()
		// let startingYear = 2021
        // let yearNow = parseInt(new moment().format("Y"))

        // for(var i = yearNow; i >= startingYear ; i--) {
          
        //   this.rangeOption[`S2 ${i}`] = [new Date(i , 6 , 1) , new Date(i , 12 , 0)]
        //   this.rangeOption[`S1 ${i}`] = [new Date(i , 0 , 1) , new Date(i , 6 , 0)]
        // }
	},
	methods: {
		viewPurchaseList (x) {
			if(this.IsJsonString(x))
				x = JSON.parse(x);

			this.$store.state.woFilterLast = {
				filter: this.filter,
				page: this.page
			};

			this.$router.push({
				name: "EstimatorParts",
				params: { id: x.form_code.replace(/"/g, "") }
			});
		},
		isiPage(page) {
			this.page = page;
		},
		isiData(data) {
			data = JSON.parse(data);
			this.$router.push({
				name: "InsertCarData",
				params: { form_code: data.form_code }
			});
		},
		async showDetailLog(log_id, name) {
			this.logName = name;
			let url = "/api/v1/workorder/status/wo/" + log_id;
			url = await this.processFilter(url, this.filter);
			this.$http
				.get(url)
				.then(resp => {
					this.woStatusLog = resp.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		createNewWorkOrder() {
			this.$router.push({ name: "WorkOrderFormNew" });
		},
		viewDetailWO(x) {
			console.log(x)
			if(this.IsJsonString(x))
				x = JSON.parse(x);
			
			this.$store.state.woFilterLast = {
				filter: this.filter,
				page: this.page
			};

			// let pathName = 'WorkOrderDetail'
			// if(x.version > 1)
			// 	pathName += `V${x.version}`

			this.$router.push({
				name: 'WorkOrderDetailV2',
				params: { type: "wo" },
				query: { wo: x.form_code.replace(/"/g, "") }
			});
		},
		IsJsonString(str) {
			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}
			return true;
		},
		viewEstimasiWO(x) {
			// console.log(x)
			if(this.IsJsonString(x))
				x = JSON.parse(x);


			
			if (!x.customer_name && !x.showWO.includes('PM')) {
				this.$store.dispatch("triggerAlert", [
					false,
					"Mohon Isi Detil Mobil Terlebih Dahulu"
				]);
				return;
			}
			
			this.$store.state.woFilterLast = {
				filter: this.filter,
				page: this.page
			};
			this.$router.push({
				name: "EstimatorApplication",
				params: { id: x.form_code.replace(/"/g, "") }
			});
		},
		async getWoStatus() {
			let url = "/api/v1/workorder/listing/step";
			url = await this.processFilter(url, this.filter);
			this.$http
				.get(url)
				.then(resp => {
					// this.woStatus = resp.data.data
					console.log(resp.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		processFilter(urlString, filter) {
			let keys = Object.keys(filter);
			let startQuery = "?";
			for (var i = 0; i < keys.length; i++) {
				if (filter[keys[i]] && filter[keys[i]] != "")
					startQuery += `${keys[i]}=${filter[keys[i]]}&`;
			}

			return urlString + startQuery;
		}
	},
	watch: {
		"selected.date" () {
			// console.log
			this.filter.start = new moment(this.selected.date[0]).startOf('month').format('Y-MM-DD')
			this.filter.end = new moment(this.selected.date[1]).endOf('month').format('Y-MM-DD')
		},
		"vue_universal_table.update": function() {
			// this.getWoStatus()
			this.$store.state.woFilterLast = {
				filter: this.filter,
				page: this.page
			};
			console.log(this.$store.state.woFilterLast)
		}
	}
};
</script>

<style scoped>
.hoverStatus:hover {
	background-color: #999;
}
</style>

<style>
	.card-workorder .card-header {
		background-color : #fff;
		font-size: 16px;
	}

	.card-workorder .text-white {
		color : white !important;
	}

	.card-workorder .nav-item {
		background-color: #999;
		border-radius: 5px 5px 0px 0px;
		
	}

	.card-workorder .bg-black {
		background-color : #222 !important;
	}

	.card-workorder {
		border : none;
	}

	

</style>

<style>
	.datepickerSeperator .el-range-separator {
		margin-top : 5px;
		margin-right : 5px;
	}

	.datepickerSeperator .el-input__icon {
		margin-top : 3px;
	}
</style>